import { initFirebase, trackAppDownload } from "./firebase.js";

// Mobile navigation toggle + active header
document.addEventListener("DOMContentLoaded", () => {
  initFirebase();

  const navToggle = document.querySelector(".header__nav-toggle");
  const nav = document.querySelector(".header__nav");
  const header = document.querySelector(".site-header");
  const appStoreLink = document.getElementById("appstore-link");
  const playStoreLink = document.getElementById("playstore-link");

  if (navToggle && nav) {
    navToggle.addEventListener("click", () => {
      nav.classList.toggle("header__nav--open");
    });

    // Close menu when clicking a link (on mobile)
    nav.addEventListener("click", (e) => {
      if (e.target.tagName === "A" && nav.classList.contains("header__nav--open")) {
        nav.classList.remove("header__nav--open");
      }
    });
  }

  // Add a small shadow when scrolling
  window.addEventListener("scroll", () => {
    if (window.scrollY > 10) {
      header.classList.add("site-header--scrolled");
    } else {
      header.classList.remove("site-header--scrolled");
    }
  });

  // Set current year in all footers
  const yearSpans = document.querySelectorAll("#year");
  const year = new Date().getFullYear();
  yearSpans.forEach((span) => {
    span.textContent = year;
  });

  const attachDownloadTracking = (el, platform) => {
    if (!el) return;
    el.addEventListener("click", () => trackAppDownload(platform));
  };

  attachDownloadTracking(appStoreLink, "ios");
  attachDownloadTracking(playStoreLink, "android");
});
